/* eslint-disable max-len */
import get from 'lodash.get';
import { combineEpics } from 'redux-observable';

import { filter } from 'rxjs/operators/filter';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { withLatestFrom } from 'rxjs/operators/withLatestFrom';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';

import { of } from 'rxjs/observable/of';

import { empty } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  SUBMIT_ADDRESS_SCREEN,
  SUBMIT_SHIPPING_SCREEN,
} from '../../actions/screens';
import { setRoute } from '../../actions/routes';
import CHECKOUT_STEPS_ROUTES from '../../routes/checkout';

import addStreamSideEffects from './addStreamSideEffects';
import createPartitions from './createPartitions';
import mapScreenState from './mapScreenState';
import mergePartitions from './mergePartitions';
import handleResults from './handleResults';

import { catchUnexpectedErrors } from '../helpers/errors';
import { setCartShippingOption } from '../../graphql/cart';
import getCartId from '../../graphql/helpers/getCartId';
import logger from '../helpers/logger';

const checkAddressFormValidityEpic = (action$, state$, { apolloClient }) =>
  action$.ofType(SUBMIT_ADDRESS_SCREEN).pipe(
    mapScreenState(state$, apolloClient),
    logger('mapScreenState'),
    // Create a new observable to avoid terminating the epic
    map((screenState) => of(screenState)),
    switchMap((mappedScreenState) =>
      mappedScreenState.pipe(
        createPartitions(),
        logger('createPartitions'),

        addStreamSideEffects(apolloClient),
        logger('addStreamSideEffects'),

        mergePartitions(),
        logger('mergePartitions'),

        handleResults(mappedScreenState),
        logger('handleResults'),

        // Ignore empty actions
        filter((a) => !!a),
        catchUnexpectedErrors(),
        logger('catchUnexpectedErrors')
      )
    )
  );

const checkShippingFormValidityEpic = (action$, state$, { apolloClient }) =>
  action$.ofType(SUBMIT_SHIPPING_SCREEN).pipe(
    mergeMap((action) => of(action)),
    logger('SUBMIT_SHIPPING_SCREEN 1'),
    mergeMap(
      () => getCartId(apolloClient),
      (props, cartId) => ({
        cartId,
      })
    ),
    logger('SUBMIT_SHIPPING_SCREEN 2'),
    withLatestFrom(state$),
    logger('SUBMIT_SHIPPING_SCREEN 2.5'),
    mergeMap(([{ cartId }, { form }]) => {
      const shippingOptionId = get(form, 'checkout.values.shipping_method');

      return apolloClient.mutate({
        mutation: setCartShippingOption,
        variables: {
          shippingOptionId,
          cartId,
        },
      });
    }),
    logger('SUBMIT_SHIPPING_SCREEN 3'),
    mergeMap(() => of(setRoute(CHECKOUT_STEPS_ROUTES.review.path))),
    logger('SUBMIT_SHIPPING_SCREEN 4'),
    // Ignore errors here. They are catched by the global error handler
    catchError(() => empty())
  );

const screensEpic = combineEpics(
  checkAddressFormValidityEpic,
  checkShippingFormValidityEpic
);
export { checkAddressFormValidityEpic, checkShippingFormValidityEpic };
export default screensEpic;
